export default __webpack_public_path__ + "static/media/headsplitting.914a6bee.png";